import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { FormPage } from '@/components/page/FormPage';
import { UserForm } from '@/features/users/components/UserForm';

export const Route = createFileRoute('/_baseLayout/users/create')({
  component: UsersCreatePage,
});

export function UsersCreatePage() {
  const { t } = useLingui();

  return (
    <FormPage
      title={t`Create user`}
      breadcrumbs={[
        { label: t`Users`, to: '/users' },
        { label: t`Create user`, to: '/users/create' },
      ]}
    >
      <UserForm />
    </FormPage>
  );
}
